module.exports = __webpack_public_path__ + "img/bag.59531114.svg";